var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 2.298L2.72.011c.65 2.012 2.417 3.456 4.497 3.456a4.5 4.5 0 0 0 2.775-.966l2.656 2.319c-1.437 1.407-3.342 2.263-5.43 2.263C4.068 7.083 1.34 5.14 0 2.298z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M.838.01l2.48 2.182a5.604 5.604 0 0 0-.271 1.735c0 .597.092 1.17.26 1.7L.812 7.783A9.419 9.419 0 0 1 0 3.927 9.41 9.41 0 0 1 .838.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M2.675 7.081L.015 4.784C1.339 1.94 3.99 0 7.045 0c2.196 0 4.183 1.003 5.62 2.624l-2.303 2.605c-.845-.962-2.02-1.558-3.317-1.558-2.003 0-3.71 1.419-4.37 3.41z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.348 14.866l-2.637-2.168a4.824 4.824 0 0 0 1.677-2.236H8V7.083h7.827a8.381 8.381 0 0 1 .13 2.552 8.233 8.233 0 0 1-2.61 5.231z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#34A853",
    transform: "translate(.667 9.917)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FBBC05",
    transform: "translate(0 4.25)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#EA4335",
    transform: "translate(.667)",
    xlinkHref: "#c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a9f20b151e06647cb465d9fd6838e099.svg";
export { ForwardRef as ReactComponent };